import {Moment} from 'moment';
import moment from 'moment';
import * as _ from "lodash";
import { isNullOrUndef } from './format';

type DateTypes = 'seconds' | 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';

export const TOMORROW: number = Number(dateStringToUnix(dateTomorrow()));

export function concatTimesFormatByISOString(
    moment1: Moment | undefined | null,
    moment2: Moment | undefined | null,
    separator: string
): string {
    const time1 = moment1 ? moment1.toISOString() : '';
    const time2 = moment2 ? moment2.toISOString() : '';
    return [time1, time2].join(separator);
}

export function dateUnixToString(value, reduceBy = -3, format = 'YYYY-MM-DD'): string {
    return moment.unix(value.slice(0, reduceBy)).format(format);
}

export function dateUnixToStringNoReduce(value, format = 'YYYY-MM-DD'): string {
    return moment.unix(value).format(format);
}

export function timeSecondsToFormat(value): string {
    if (value.match(/[0-9]+:[0-9]+:[0-9]+/)) return value;
    return moment.utc(value * 1000).format('HH:mm:ss');
}

export function timeFormatToSeconds(value): any {
    return moment.duration(value).asSeconds();
}

export function dateStringToUnix(value, increaseBy = 3): string {
    if (_.isNumber(value)) return String(value);
    return moment(value).unix() + _.repeat('0', increaseBy);
}

// ts = epoch timestamp
// returns date obj
export function epochToJsDate(ts: number) {
    return new Date(ts * 1000);
}

// d = javascript date obj
// returns epoch timestamp
export function jsDateToEpoch(d: Date) {
    return (d.getTime() - d.getMilliseconds()) / 1000;
}

export function getDaysInWeek(current) {
    const week = [];
    current = new Date(current);

    // Starting Sunday
    current.setDate((current.getDate() - current.getDay()));
    // tslint:disable-next-line
    for (var i = 0; i < 7; i++) {
        week.push(
            new Date(current)
        );
        current.setDate(current.getDate() + 1);
    }
    return week;
}

export function getDaysInMonth(month, year, current = null) {
    if (current) {
        month = new Date(current).getMonth();
        year = new Date(current).getFullYear();
    }

    const date = new Date(year, month, 1);
    const days = [];
    while (date.getMonth() === month) {
        days.push(new Date(date));
        date.setDate(date.getDate() + 1);
    }
    return days;
}

export function splitTimeRange(timeRange: string | undefined | null, separator: string): string[] {
    let time1 = '';
    let time2 = '';
    if (timeRange) {
        const dates = (timeRange as string).split(separator, 2);
        if (dates.length === 2) {
            [time1, time2] = dates;
        }
    }
    return [time1, time2];
}

export function dateToday(format = 'YYYY-MM-DD'): string {
    return moment(new Date()).format(format);
}

export function lastDateMonth(format = 'YYYY-MM-DD') {
    return moment().endOf('month').format(format);
}

export function dateTomorrow(format = 'YYYY-MM-DD') {
    return moment(new Date()).add(1, 'd').format(format);
}

export function dateToString(dt, onlyDate = false) {
    const dateStr = moment(new Date(dt)).set({hour: 0, minute: 0, second: 0, millisecond: 0}).format();
    if (onlyDate) {
        return dateStr.slice(0, 10);
    }
    return dateStr.slice(0, 19);
}

export function dateAfter(dt, amount: { [key in DateTypes]?: number }) {
    // example param: {'days': 1, 'months': 2, 'hours': 3}
    const _dt = dt ? new Date(dt) : new Date();
    return moment(_dt).add(amount);
}

export function datetimeToStandardString(dt = null) {
    const _dt = dt ? new Date(dt) : new Date();
    return moment(_dt).format('MM/DD/YYYY hh:mm:ss');
}

export function toDateFromTimestamp(dateStr, params) {
    dateStr = String(dateStr);
    const cutLength = !isNullOrUndef(params[1]) ? params[1] : 3;
    return moment.unix(parseInt(dateStr.substring(0, dateStr.length - cutLength))).format(params[0]);
}
